import type { Country } from 'react-phone-number-input'

export const DEFAULT_PHONE_COUNTRY: Country = 'US'

const SPECIAL_SYMBOLS = ['-', ' ', '(', ')']
const REG_EXP = new RegExp(SPECIAL_SYMBOLS.join('|\\'), 'gi')

export function formatPhoneNumber(phoneNumber: string): string {
  return phoneNumber ? phoneNumber.replace(REG_EXP, '') : ''
}

export function getFormattedPhoneNumbersForSubmission(
  rawPhoneNumber: string[],
): string[] {
  const formattedPhoneNumbers = rawPhoneNumber
    .map(phoneNumber => getFormattedPhoneNumberForSubmission(phoneNumber))
    .filter(v => !!v)
  const uniquePhoneNumbers = Array.from(new Set(formattedPhoneNumbers))
  return uniquePhoneNumbers
}

export function getFormattedPhoneNumberForSubmission(
  rawPhoneNumber: string,
): string {
  return isPhoneNumberEntered(rawPhoneNumber)
    ? formatPhoneNumber(rawPhoneNumber)
    : ''
}

// A phone is "cleared" when the form LOADED a number and the user submitted none.
export function wasPhoneCleared(
  loadedPhone: string,
  submittedPhone: string,
): boolean {
  return !!loadedPhone && !submittedPhone
}

// PhoneInput emits '' when the number is cleared, so any digit means something was entered.
export function isPhoneNumberEntered(phoneNumber: string): boolean {
  return /\d/.test(phoneNumber ?? '')
}
